import * as PATIENT from '@/store/constants/patient';

export default {
  [PATIENT.GET_PATIENT_LIST]: (state) => {
    return state.list;
  },

  [PATIENT.GET_PATIENT]: (state) => {
    return state.patient;
  }
}


// WEBPACK FOOTER //
// ./src/store/patient/getters.js